import { Loader } from '@googlemaps/js-api-loader'

export default function ({ app, $config }, inject) {
  const GoogleLoader = new Loader({
    apiKey: $config.googleMapsApiKey,
    version: 'weekly'
  })
  inject('GoogleLoader', GoogleLoader)
}
